import { schema } from 'normalizr'

import user from './user'

const tableBillSplit = new schema.Entity('tableBillSplits', {
  payment_user: user,
})

export default tableBillSplit
